(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["engraving-input"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.engraving-input').forEach(input => {
    const characterCount = input.parentElement.querySelector('[data-character-count]');
    if (characterCount) {
      input.addEventListener('input', () => {
        characterCount.textContent = input.value.length;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
